import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { TableState } from 'react-table';
import { NameChangeReviewGridItem, SortableDraftNameChangeFields } from 'shared/types';
import { GetDraftNameChangesResponse } from 'shared/services';
import { useQueryDraftNameChange } from 'shared/queries/query-draft-name-change';

const defaultState: TableState<NameChangeReviewGridItem> = {
  selectedRowIds: {},
  pageIndex: 0,
  pageSize: 100,
  globalFilter: '',
  filters: [],
  sortBy: [],
  hiddenColumns: [],
};

export interface NameChangeApprovalWorkflowTableState {
  tableState: TableState<NameChangeReviewGridItem>;
}

interface NameChangeApprovalWorkflowListContext {
  nameChangeApprovalWorkflowTableState: NameChangeApprovalWorkflowTableState;
  setNameChangeApprovalWorkflowTableState: React.Dispatch<React.SetStateAction<NameChangeApprovalWorkflowTableState>>;
  nameChanges: GetDraftNameChangesResponse | undefined;
  isFetching: boolean;
  isLoading: boolean;
}
const nameChangeApprovalWorkflowListContext = createContext({} as NameChangeApprovalWorkflowListContext);

export function ProvideNameChangeApprovalWorkflowListState({ children }: PropsWithChildren<{}>) {
  const [
    nameChangeApprovalWorkflowTableState,
    setNameChangeApprovalWorkflowTableState,
  ] = useState<NameChangeApprovalWorkflowTableState>({
    tableState: defaultState,
  });

  const { nameChanges, isFetching, isLoading } = useQueryDraftNameChange({
    page: nameChangeApprovalWorkflowTableState.tableState.pageIndex,
    pageSize: nameChangeApprovalWorkflowTableState.tableState.pageSize,
    sortOrder: !!nameChangeApprovalWorkflowTableState.tableState.sortBy[0]
      ? nameChangeApprovalWorkflowTableState.tableState.sortBy[0].desc
        ? 'desc'
        : 'asc'
      : undefined,
    sortBy: !!nameChangeApprovalWorkflowTableState.tableState.sortBy[0]
      ? (nameChangeApprovalWorkflowTableState.tableState.sortBy[0].id as SortableDraftNameChangeFields)
      : undefined,
  });

  return (
    <nameChangeApprovalWorkflowListContext.Provider
      value={{
        nameChangeApprovalWorkflowTableState,
        setNameChangeApprovalWorkflowTableState,
        nameChanges,
        isFetching,
        isLoading,
      }}
    >
      {children}
    </nameChangeApprovalWorkflowListContext.Provider>
  );
}

export function useNameChangeApprovalWorkflowListState() {
  return useContext(nameChangeApprovalWorkflowListContext);
}
